import { getItemAnimationDelay } from '../../../helpers/get-item-animation-delay';
var NAV_BAR_ITEM_ANIMATION_DELAY = 86;
export var getNavBarAnimationDelay = function getNavBarAnimationDelay() {
  var columnNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var rowNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return getItemAnimationDelay({
    delayInMs: NAV_BAR_ITEM_ANIMATION_DELAY,
    itemIndex: columnNumber + rowNumber
  });
};